<template>
  <DSDropdownMenuItem
    as-child
    :data-refid="`sidebarGroupItem${child.label?.replace(' ', '')}`"
    @select="emit('select')"
  >
    <DSSidebarGroupChild
      :icon="isDashboard ? GripVerticalIcon : child.icon || LayoutDashboardIcon"
      :label="child.label || ''"
      :data-handle="isDashboard || undefined"
      :class="!!child.active
        ? 'bg-accent text-accent-foreground font-semibold'
        : 'hover:bg-foreground/3! text-foreground/80! hover:text-foreground!'"
    >
      <template #label>
        <DashboardRename
          v-model="editing"
          :label="child.label || ''"
          @save="handleSave"
        >
          <span class="min-w-0 flex-1 truncate">{{ child.label }}</span>
        </DashboardRename>
      </template>
      <template
        v-if="isDashboard"
        #trailing
      >
        <DashboardActions
          :disabled="isEditMode"
          :child
          trigger-class="-mr-1 size-7 rounded-ds-sm text-primary/50 hover:bg-primary/5"
          @rename="handleRename"
        />
      </template>
    </DSSidebarGroupChild>
  </DSDropdownMenuItem>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { NavigationItem } from '@types'

import { DSDropdownMenuItem, DSSidebarGroupChild } from '@ds'

import { GripVerticalIcon, LayoutDashboardIcon } from '@lucide/vue'

import DashboardActions from './DashboardActions.vue'
import DashboardRename from './DashboardRename.vue'

type Props = {
  child: NavigationItem
  isDashboard?: boolean
  isEditMode?: boolean
}

const { child, isDashboard } = defineProps<Props>()

const emit = defineEmits<{
  select: []
}>()

const editing = ref(false)

const handleRename = () => {
  editing.value = true
}

const handleSave = (value: string) => {
  child.update?.(value)
}
</script>
